import { Component } from '@angular/core';
import { ListService } from '@shared/modules/list/services/list.service';

@Component({
  selector: 'list-loader',
  templateUrl: './list-loader.component.html'
})
export class ListLoaderComponent {
  constructor(public service: ListService) {}
}
